import { combineReducers } from "redux";
import { basket } from "./basket";
import { shipping } from "./shipping";
import { store } from "./store";

const Reducers = combineReducers({
  basket,
  shipping,
  store,
});

export default Reducers;
